module.exports = __webpack_public_path__ + "img/driver-position-icon.088ff4aa.png";